import clsx from 'clsx'
import { Outlet, useLocation } from 'react-router-dom'
import { SelectLanguage } from '../../../components/SelectedLanguage'
import { ReactComponent as Logo } from '../../../assets/svgs/logo.svg'

export const Root = () => {
  const { pathname } = useLocation()

  return (
    <div
      className={clsx('w-full grow bg-none', {
        'lg:bg-wallpaper-auth lg:bg-no-repeat lg:bg-cover lg:bg-fixed': !['/expert/register/terms', '/expert/accept-terms'].includes(pathname)
      })}
    >
      <header className="container flex items-center px-6 py-4 mx-auto">
        <Logo
          className={clsx('h-auto', {
            'w-24 lg:w-0': pathname !== '/expert/register/terms',
            'w-24': pathname === '/expert/register/terms',
          })}
        />
        <div className="ml-auto w-fit">
          <SelectLanguage
            color={pathname === '/expert/register/terms' ? 'dark' : 'light'}
          />
        </div>
      </header>

      <main className="container flex flex-col mx-auto grow">
        <Outlet />
      </main>
    </div>
  )
}
